<script>
  import { router } from '@inertiajs/svelte'
  
  let { alert = '' } = $props();
  
  let email = $state('');
  
  function submit(event) {
    event.preventDefault();
    router.post('/identity/password_reset', {
      email
    });
  }
</script>

<div class="password-reset-container">
  {#if alert}
    <p class="alert">{alert}</p>
  {/if}
  
  <h1>Forgot your password?</h1>
  
  <form onsubmit={submit}>
    <div class="form-group">
      <label for="email" class="form-label">Email</label>
      <!-- svelte-ignore a11y_autofocus -->
      <input 
        id="email" 
        type="email" 
        bind:value={email} 
        required 
        autofocus
        class="form-input"
        placeholder="Enter your email address"
      />
    </div>
    
    <div class="form-actions">
      <button type="submit" class="reset-button">Send password reset email</button>
    </div>
  </form>
  
  <div class="sign-in-link">
    <a href="/sign_in">Return to sign in</a>
  </div>
</div>

<style>
  .password-reset-container {
    max-width: 500px;
    margin: 0 auto;
    padding: 2rem 1rem;
  }
  
  h1 {
    font-size: 1.875rem;
    font-weight: 600;
    margin-bottom: 1.5rem;
  }
  
  .alert {
    color: red;
    margin-bottom: 1rem;
  }
  
  .form-group {
    margin-bottom: 1.25rem;
  }
  
  .form-label {
    display: block;
    font-weight: 500;
    margin-bottom: 0.375rem;
  }
  
  .form-input {
    width: 100%;
    padding: 0.625rem;
    border: 1px solid #d1d5db;
    border-radius: 0.375rem;
    font-size: 1rem;
  }
  
  .form-actions {
    margin-top: 1.5rem;
  }
  
  .reset-button {
    background-color: #047857;
    color: white;
    border: none;
    padding: 0.625rem 1.25rem;
    border-radius: 0.375rem;
    font-weight: 500;
    font-size: 1rem;
    cursor: pointer;
    width: 100%;
  }
  
  .reset-button:hover {
    background-color: #065f46;
  }
  
  .sign-in-link {
    margin-top: 1.5rem;
    text-align: center;
  }
  
  .sign-in-link a {
    color: #047857;
    text-decoration: none;
  }
  
  .sign-in-link a:hover {
    text-decoration: underline;
  }
</style>